import { render } from "./modal.vue?vue&type=template&id=58afa07c&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=58afa07c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58afa07c"

export default script